module.exports = __webpack_public_path__ + "img/link-hook.228c6a35.svg";